import type { Key } from 'swr'

interface ErrorWithSwrKey extends Error {
  swrKey: Key
}

const hasSwrKey = (error: unknown): error is ErrorWithSwrKey => error instanceof Error && 'swrKey' in error

export const tagSwrError = (error: unknown, key: Key) => {
  if (error instanceof Error) {
    ;(error as ErrorWithSwrKey).swrKey = key
  }

  return error
}

export const getSwrErrorKey = (error: unknown) => (hasSwrKey(error) ? error.swrKey : null)
